import type { WithMetadata } from "../../pages";
import { Footer as CompareTheMarketFooter } from "./CompareTheMarketFooter";
import { Footer as Control } from "./Footer";
import { Footer as MoneySuperMarketFooter } from "./MoneySuperMarketFooter";
import { Footer as GoCompareFooter } from "./GoCompareFooter";
import type { FooterProps } from "./types";

export const Footer = (props: WithMetadata<FooterProps>) => {
  const { variant } = props;

  switch (variant) {
    case "moneysupermarket":
      return <MoneySuperMarketFooter {...props} />;
    case "comparethemarket":
      return <CompareTheMarketFooter {...props} />;
    case "gocompare":
      return <GoCompareFooter {...props} />;
    default:
      return <Control {...props} />;
  }
};

export * from "./types";
